<template>
  <div id="publicClass_details">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">
        您当前所在位置：<a href="/">首页</a>>>
        <router-link :to="{ path: '/publicclass_list', query: { nav: 3 } }" active-class="side" exact>热门公开课
        </router-link>
        >><span>{{ Title }}</span>
      </div>
    </div>
    <div class="box_top clearfix">
      <div class="box_top_box clearfix">
        <dl class="clearfix">
          <dt class="fl"><img :src="listDetails.CoverImg" /></dt>
          <dd class="fl">
            <h2>{{ listDetails.Title }}</h2>
            <div class="p1">
              <span>{{ listDetails.CourseTypeName }}</span><span>{{ listDetails.SubjectTypeName }}</span>
            </div>
            <div class="p2" v-if="ApplyStudentType">
              <strong>适合学生：</strong>
              <p>
                <span v-for="(i, index) in ApplyStudentType">{{ i }}</span>
              </p>
            </div>
            <div class="p3 djsName" v-if="djsstatus === 1">
              <span>直播倒计时：</span>
              <FlipDown :endDate="startTime" @timeUp="commitExamTest()" :type="4" :theme="2"
                :timeUnit="['天', '：', '：', '']" class="flip-down" />
            </div>
            <div class="p4" v-else-if="djsstatus === 2">
              <span>直播状态：</span>
              <p>直播进行中</p>
            </div>
            <div v-else-if="djsstatus === 3">
              <span>直播状态：</span>
              <p>回放视频制作中</p>
            </div>
            <div class="p4" v-else>
              <span>直播状态：</span>
              <p>直播已结束</p>
            </div>
          </dd>
        </dl>

        <div class="content_box">
          <div class="tcimg">
            <img class="teacher_head" :src="HeadUrl" alt="启德老师" />
          </div>
          <h3>{{ TeacherName }}</h3>
          <p class="teacher_instr">
            <img src="../../assets/publicClass/teacher_ico1.png" alt="" /><span>{{ JobTitle }}</span>
          </p>
          <p class="fans_box">
            <span>粉丝：{{ FansCount }}</span>
            <span>高分案例：{{ CaseNum }}</span>
          </p>
          <div class="attention_btn" v-if="!Status" @click="Attention">
            关注
          </div>
          <div class="attention_btn" v-else>已关注</div>
        </div>
      </div>
      <div class="box_top_b">
        <strong>￥{{ Price }}</strong>
        <span class="ljyy" v-if="anys === 1" @click="ljyy">立即预约</span>
        <span class="yyy" v-else-if="anys === 2">已预约</span>
        <span class="ljjr" v-else-if="anys === 3" @click="paypd">立即进入直播间</span>
        <span class="ckhf1" v-else-if="anys === 4">查看回放</span><!-- 回放视频制作中 -->
        <span class="ckhf" v-else-if="anys === 5" @click="paypd">查看回放</span>
      </div>
      <!-- 老师关注 -->
    </div>
    <div class="main public_wrap">
      <div class="main_top" v-if="tabqh == 0">
        <div class="link_box">
          <ul>
            <li class="Introduction" :class="{ active: tabqh == 0 }" @click="tabFun(0)">
              课程介绍
              <p></p>
            </li>
          </ul>
        </div>
        <div class="main_top_center">
          <video width="1020" height="574" controls :poster="CoverImg" v-if="CoverVideo">
            <source :src="CoverVideo" />
          </video>
          <p v-html="Synopsis"></p>
        </div>
      </div>
    </div>
    <div class="yycg_tan" v-if="ljyycg">
      <img src="../../assets/publicClass/yycg_tan.png" width="272" />
      <h2>预约成功</h2>
      <p>
        课程开始前 30 分钟我们会短信提醒您。<br />
        您可以到个人中心查询或取消该预约。
      </p>
      <span @click="closeTan">确定</span>
    </div>
    <tem-login></tem-login>
  </div>
</template>
<script>
  import Header from "../../components/header/Header.vue"; //公共头部
  import temLogin from "../../components/login";
  import publicClass from "../../page2/public/publicClass"; //热门公开课
  
  import FlipDown from "vue-flip-down";
  export default {
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,
      
      FlipDown,
      temLogin,
      publicClass
    },
    metaInfo() {
      return {
        title: this.setting.title,
        meta: [{
            name: "keywords",
            content: "启德考培在线课程,雅思在线课程,托福在线课程,雅思课程,托福课程"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          }
        ]
      };
    },
    data() {
      return {
        setting: {
          title: "启德考培旗下在线课堂_出国考试在线培训_考培网校"
        },
        ApplyStudentType: [],
        VideoId: "", //直播Id
        VideoToken: "", //直播Token
        tokenkey: "",
        data1: "",
        anys: 1,
        onOff: false,
        djsstatus: 1,
        ljyycg: false,
        listDetails: [],
        kcListId: "", //课程ID
        Title: "", //标题
        TeacherName: "", //第一个老师姓名
        TeacherIds: "", //老师ID
        HeadUrl: "", //头像
        FansCount: "",
        CaseNum: "",
        JobTitle: "",
        Status: "", //关注老师状态
        CourseTypeName: "", //课程名称
        SubjectTypeName: "", //科目名称
        CoverImg: "", //视频封面
        CoverVideo: "", //视频
        Synopsis: "", //视频简介
        Price: "", //价格
        ApplyStudentName: "", //简介
        BeginTime: 0, //直播开始时间
        EndTime: 0, //直播结束时间
        startTime: 0,
        endT: 0,
        yykcoff: "",
        EndTimeB: 0,
        nowT: "",
        tabqh: 0 //切换
      };
    },
    // beforeRouteEnter(to,from,next) {
    //   next(vm=>{
    //     vm.targetUser = to.params.KId
    //   })
    // },

    // updated() {
    // },
    // beforeRouteEnter() {
    //   // console.log(this)
    //   // this.commitExamTest()
    // },
    watch: {
      $route() {
        this.handelData(); //初始化数据
        this.reloads(); //加载登录后信息
        this.commitExamTest();
        //location.reload()//调转页面时定时器从新加载页面
        // this.$nextTick(()=>{
        //   this.commitExamTest()
        // })
      },
      scrollH() {
        // console.log(document.body.scrollTop)
      }
    },

    mounted: function() {
      //自动触发写入的函数
      let that = this;
      that.tokenkey = that.$cookies.get("token");
      this.handelData();
      window.scroll(500, 500);
      //加载完页面后判断课程是否已预约
      // 页面加载判断课程是否预约
      if (!that.tokenkey) {
        return;
      }
      this.teacher_Status();
      that.buyCourseStatus();
    },

    methods: {
      //课程是否预约
      buyCourseStatus() {
        let that = this;
        //页面加载判断课程是否预约,contentType=183(热门公开课详情页的值是183)
        let classId = this.$route.query.KId;
        return new Promise(function(reject, resolve) {
          that.$http
            .get(
              "https://schoolapi.eiceducation.com.cn/api/BuyCourseStatus?courseId=" +
              classId +
              "&contentType=183", {
                headers: {
                  "content-type": "application/json; charset=utf-8",
                  token: that.tokenkey
                }
              }
            )
            .then(function(result) {
              // 判断是否购买此课程
              if (result.data.succ) {
                that.anys = 2; //已购买
              } else {
                that.anys = 1; //未购买
              }

              reject({
                Status: that.anys
              });
            })
            .catch(function(error) {
              // console.log(error);
            });
        });
      },
      tabFun(a) {
        this.tabqh = a;
        if (a == 0) {
          this.$router.push({
            path: "",
            query: {
              nav: 3,
              KId: this.kcListId
            }
          });
        } else {
          this.$router.push({
            path: "",
            query: {
              nav: 3,
              KId: this.kcListId
            }
          });
        }
      },
      // 点击老师箭头
      left_btn() {
        this.onOff = !this.onOff;
      },
      //关注老师
      Attention() {
        let that = this;
        // // console.log(that.TeacherIds)
        if (that.tokenkey) {
          this.$http
            .post(
              "https://schoolapi.eiceducation.com.cn/api/Collection", {
                type: 2,
                ContentId: that.TeacherIds
              }, {
                headers: {
                  ContentType: "application/json",
                  token: that.tokenkey
                }
              }
            )
            .then(function(result) {
              // console.log(result.data)
              if (result.data.code == 200) {
                that.Status = result.data.succ;
                that.$message.success("老师已关注成功");
              } else {
                that.$message.warning("老师已关注");
              }
            })
            .catch(function(error) {
              // console.log(error);
            });
        } else {
          // 判断登录弹窗
          return (this.$refs.header.$refs.login.logintc = true);
        }
      },
      handelData() {
        let that = this;
        that.data1 = that.listDetails;
        that.tokenkey = that.$cookies.get("token");
        that.kcListId = this.$route.query.KId;
        //// console.log(that.kcListId)
        return new Promise(function(reject, resolve) {
          that.$http
            .get(
              "https://schoolapi.eiceducation.com.cn/api/OpenCourse/" +
              that.kcListId
            )
            .then(function(response) {
              that.listDetails = response.data.results;
              // console.log(that.listDetails)
              let str = response.data.results.ApplyStudentName.split(",");
              that.ApplyStudentType = str; //适合人群
              that.Id = response.data.results.Id; //课程Id
              that.TeacherIds = response.data.results.TeacherIds; //老师Id
              that.Title = response.data.results.Title; //标题
              that.setting.title =
                response.data.results.Title +
                " - 启德考培旗下在线课堂_出国考试在线培训_考培网校";
              that.TeacherName = response.data.results.Staff[0].Name; //第一个老师姓名
              that.HeadUrl = response.data.results.Staff[0].HeadUrl; //头像
              that.JobTitle = response.data.results.Staff[0].JobTitle; //岗位
              that.FansCount = response.data.results.Staff[0].FansCount; //粉丝
              that.CaseNum = response.data.results.Staff[0].CaseNum; //案例
              that.RoomId = response.data.results.RoomId; //房间号
              that.CourseTypeName = response.data.results.CourseTypeName; //课程名称
              that.SubjectTypeName = response.data.results.SubjectTypeName; //科目名称
              that.ApplyStudentName = response.data.results.ApplyStudentName; //简介
              that.BeginTime = response.data.results.BeginTime; //直播开始时间
              that.EndTime = response.data.results.EndTime; //直播开始时间
              that.Price = response.data.results.Price; //价格
              that.CoverImg = response.data.results.CoverImg; //视频封面
              that.CoverVideo = response.data.results.CoverVideo; //视频
              that.Synopsis = response.data.results.Synopsis; //视频介绍
              that.VideoId = response.data.results.VideoId; //视频Id
              that.VideoToken = response.data.results.VideoToken; //视频Token
              that.TxVideoId = response.data.results.TxVideoId; //腾讯云点播ID
              that.Title = response.data.results.Title; //房间名

              // 倒计时
              that.startTime = new Date(
                response.data.results.BeginTime.replace("-", "/").replace(
                  "-",
                  "/"
                )
              ).getTime(); //倒计时开始时间
              that.EndTimeB = new Date(
                response.data.results.EndTime.replace("-", "/").replace("-", "/")
              ).getTime(); //倒计时结束时间
              // 跳转详情页后开始倒计时

              //that.commitExamTest()
              reject({
                a: that.startTime,
                b: that.EndTimeB,
                TeacherIds: that.TeacherIds
              });
              //resolve(111)
            })
            .catch(function() {
              // console.log('数据错误');
            });
        });
      },
      // 直播倒计时结束
      async commitExamTest() {
        let that = this;
        let {
          a,
          b
        } = await this.handelData();
        that.nowT = new Date().getTime();
        //服务器时间大于直播时间并且小于直播结束时间
        if (that.nowT >= a && that.nowT < b) {
          that.djsstatus = 2; //直播进行中
          if (!that.tokenkey) {
            return;
          }
          let buyStatus = await this.buyCourseStatus();
          if (buyStatus.Status === 1) {
            //未购买预约课程
            that.anys = 1; //按钮状态（立即预约）
          } else {
            //已购买
            that.anys = 3; //按钮状态（立即进入直播间）
          }
          that.clerTime();
        } else if (that.nowT > b) {
          //如果服务器时间大于直播结束时间
          that.clerTime();
          // 判断是否有回放
          if (that.VideoId ||that.TxVideoId) {
            that.djsstatus = 4; //查看回放
          } else {
            that.djsstatus = 3; //回放制作中
          }
          if (!that.tokenkey) {
            return;
          }
          let buyStatus = await this.buyCourseStatus();
          // // console.log(buyStatus.Status)
          if (buyStatus.Status === 1) {
            //未购买预约课程
            that.anys = 1; //按钮状态（立即预约）
          } else {
            //如果有回放Id，就能点击查看回放
            if (that.VideoId ||that.TxVideoId) {
              that.anys = 5; //按钮状态（查看回放，能点击）
            } else {
              that.anys = 4; //按钮状态（查看回放，不能点击）
            }
          }
        } else {
          //倒计时进行中，直播未开始
          that.djsstatus = 1; //直播倒计时
          if (!that.tokenkey) {
            return;
          }
          let buyStatus = await this.buyCourseStatus();
          // // console.log(buyStatus)
          if (buyStatus.Status === 1) {
            //未购买预约课程
            that.anys = 1; //按钮状态（立即预约）
          } else {
            that.anys = 2; //按钮状态（已预约）
          }
        }
      },
      // 是否关注老师
      async teacher_Status() {
        let that = this;
        let t = await this.handelData();
        let TeacherIds = t.TeacherIds;
        //// console.log(TeacherIds)
        //判断老师是否关注
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/CollectionStatus?contentId=" +
            TeacherIds, {
              headers: {
                token: that.tokenkey
              }
            }
          )
          .then(function(response) {
            // console.log(response)
            that.Status = response.data.succ;
          })
          .catch(function() {
            // console.log('数据错误');
          });
      },
      clerTime() {
        clearInterval(this.timer);
      },
      //立即预约
      ljyy() {
        let that = this;
        // 判断登录弹窗
        if (!that.$cookies.get("token")) {
          // return this.$bus.$emit("loginShow", true)//重叠两个登陆弹窗
          return (this.$refs.header.$refs.login.logintc = true);
          //// console.log(this.$children[0])
        }
        // 判断价格
        if (this.Price == 0) {
          //价格为0时（免费）预约课程
          let classId = this.$route.query.KId;
          this.$http
            .post(
              "https://schoolapi.eiceducation.com.cn/api/OpenCourse", {
                Id: classId
              }, {
                headers: {
                  "content-type": "application/json; charset=utf-8",
                  token: that.tokenkey
                }
              }
            )
            .then(function(result) {
              //// console.log(result)
              that.ljyycg = true;
              // that.anys = 2-----------------------------------------------------------------------------
              //提示已预约
              //that.$message.warning('课程已预约')
              // that.$message.error(result.data.msg);
            })
            .catch(function(error) {
              // console.log(error);
            });
        } else {
          this.paypd();
        }
      },
      closeTan() {
        //如果直播倒计时后面显示的是（直播进行中）
        // console.log()
        if (this.djsstatus == 2) {
          //按钮状态是立即进入直播间
          this.anys = 3;
          this.ljyycg = false;
        } else {
          this.ljyycg = false;
          this.anys = 2;
        }
      },
      //立即进入直播间或者是直播回放执行的函数
      paypd() {
        let that = this;
        //如果是0元课直接跳转
        if (this.Price == 0) {
          // console.log('0元直接跳转')
          if (that.anys == 5) {
            // 回放
            that.watchlog2(3, that.RoomId, that.VideoToken, that.TxVideoId, that.Title);
          } else {
            // 进入直播
            that.studio2(that.RoomId, 183, that.Id);
          }
        } else {
          //如果是支付课（判断是否支付）
          let that = this;
          let classId = this.$route.query.KId;
          //判断是否已支付
          this.$http
            .get(
              "https://schoolapi.eiceducation.com.cn/api/BuyCourseStatus?courseId=" +
              classId +
              "&contentType=183", {
                headers: {
                  "content-type": "application/json; charset=utf-8",
                  token: that.tokenkey
                }
              }
            )
            .then(function(result) {
              // console.log(result)
              //已支付直接跳转
              if (result.data.code == 200) {
                if (result.data.succ) {
                  // console.log('已购买')
                  if (that.anys == 5) {
                    // 回放
                    that.watchlog2(3, that.RoomId, that.VideoToken, that.TxVideoId, that.Title);
                  } else {
                    // 进入直播
                    that.studio2(that.RoomId, 183, that.Id);
                  }
                }
              } else if (result.data.code == 2) {
                //未支付，走支付流程
                that.$router.push({
                  path: "publicClass_order",
                  query: {
                    id: that.$route.query.KId
                  }
                });
                let data = JSON.stringify(that.listDetails);
                localStorage.setItem("data", data);
              }
            })
            .catch(function(error) {
              // console.log(error);
            });
        }
      },
      //tyoeid播放类型 1直播/2点播/3回放
      //roomid 房间号
      //按钮类型contentType 183公开课
      //contentId 公开课id
      watchlog2(tyoeid, scheduleId, videoid, videotoken, TxVideoId, title) {
        let that = this;
        // 1直播/2点播/3回放
        if (TxVideoId) {
          window.open(
            "https://online.eickaopei.com/video.html?title=" + title + "&id=" + TxVideoId, "_blank");
          return;
        }
        if (tyoeid == 2) {
          window.open(
            "https://b96135432.at.baijiayun.com/web/video/player?vid=" +
            videoid +
            "&token=" +
            videotoken +
            "&player=h5&user_number=" +
            that.$parent.UserInfos.Number +
            "&user_name=" +
            that.$parent.UserInfos.NickName,
            "_blank"
          );
        } else {
          window.open(
            "https://b96135432.at.baijiayun.com/web/playback/index?classid=" +
            videoid +
            "&token=" +
            videotoken +
            "&player=h5&user_number=" +
            that.$parent.UserInfos.Number +
            "&user_name=" +
            that.$parent.UserInfos.NickName,
            "_blank"
          );
        }
        // this.WatchLogJL(tyoeid, scheduleId, videoid)
      },
      // 进入直播间
      studio2(roomid, contentType, contentId) {
        let that = this;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/BJYSign?contentType=" +
            contentType +
            "&contentId=" +
            contentId +
            "&roomid=" +
            roomid, {
              headers: {
                token: that.tokenkey
              }
            }
          )
          .then(function(result) {
            // // console.log(result)
            // // console.log(that.$parent.UserInfos)
            let room_id = roomid; //房间号
            let user_number = that.$parent.UserInfos.Number; //用户数字ID
            let user_role = 0; //用户身份0:学生 1:老师 2:管理员
            let user_name = that.$parent.UserInfos.NickName; //用户名
            let user_avatar = that.$parent.UserInfos.HeadUrl; //用户头像
            let sign = result.data.results; //用户签名
            let web_url =
              "https://b96135432.at.baijiayun.com/web/room/enter?room_id=" +
              roomid +
              "&user_number=" +
              user_number +
              "&user_role=" +
              user_role +
              "&user_name=" +
              user_name +
              "&user_avatar=" +
              user_avatar +
              "&sign=" +
              sign;
            window.open(web_url);
          })
          .catch(function(error) {
            // console.log(error);
            that.$message.error(error);
          });
      },

      //加载登录后信息
      reloads() {
        var that = this;
        this.teacher_Status();
        let classId = this.$route.query.KId;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/BuyCourseStatus?courseId=" +
            classId +
            "&contentType=183", {
              headers: {
                "content-type": "application/json; charset=utf-8",
                token: that.tokenkey
              }
            }
          )
          .then(function(result) {
            // // console.log(result)
            if (result.data.code == 200) {
              if (result.data.succ) {
                that.anys = 2;
              }
            }
          })
          .catch(function(error) {
            // console.log(error);
          });
      }
    }
  };
</script>

<style scoped>
  .link_box ul {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #d5d5d5;
  }

  .link_box li.active {
    color: #ff4256;
  }

  .link_box li.active p {
    margin: 0 auto;
    width: 76px;
    height: 1px;
    background: #ff4256;
  }

  .Introduction {
    font-size: 20px;
    color: #333333;
    padding: 0 10px;
    line-height: 50px;
    cursor: pointer;
  }

  .public_link {
    font-size: 20px;
    color: #333333;
    padding: 0 10px;
    line-height: 50px;
    cursor: pointer;
  }

  .box_top .side {
    right: -288px;
  }

  .box_top .active {
    right: 0px;
  }

  .attention_teacher {
    transition: 0.2s;
    position: absolute;
    top: 0;
    right: 30px;
    display: flex;
    justify-content: flex-start;
    /* max-width: 1180px; */
  }

  .content_box {
    text-align: center;
    width: 288px;
    height: auto;
    background: #f7f7f7;
    border-radius: 10px;
    float: right;
    margin-top: 14px;
    margin-right: 14px;
  }

  .content_box .tcimg {
    margin: 0 auto;
    width: 93px;
    height: 93px;
    border-radius: 50%;
    margin-top: 20px;
    overflow: hidden;
  }

  .content_box .tcimg .teacher_head {
    width: 100%;
  }

  .content_box h3 {
    padding-top: 10px;
    padding-bottom: 8px;
    font-size: 18px;
    color: #333333;
    line-height: 27px;
    font-weight: normal;
  }

  .teacher_instr {
    display: flex;
    justify-content: center;
  }

  .teacher_instr span {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
  }

  .teacher_instr img {
    margin-right: 5px;
  }

  .fans_box {
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }

  .fans_box span {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    padding: 0 8px;
  }

  .attention_btn {
    margin: 0 auto;
    width: 260px;
    height: 34px;
    background: #ffac00;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 34px;
    margin-bottom: 25px;
    margin-top: 15px;
    cursor: pointer;
  }

  .btn_pointer {
    cursor: pointer;
  }

  /deep/.vue-countdown-component .time-unit {
    color: #333;
  }

  /deep/.vue-countdown-component .time-box:before {
    background: none;
  }

  /deep/.vue-countdown-component .time-box:after {
    background: none;
  }

  /deep/.vue-countdown-component .time-box {
    background-color: #ff7171;
  }

  /deep/.vue-countdown-component .time-box>div.base .base-b {
    background-color: #ff7171;
  }

  /deep/.vue-countdown-component .time-box>div.face {
    background-color: #ff7171;
  }

  /deep/.vue-countdown-component .time-box>div.back {
    background-color: #ff7171;
  }

  .bottombox {
    box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
    position: relative;
    z-index: 9;
  }

  .hotgkt {
    background: #fafafa;
  }

  .BreadcrumbNavigation {
    width: 1180px;
    text-align: left;
    font-size: 16px;
    color: #333;
    line-height: 56px;
    margin: 0 auto;
  }

  .BreadcrumbNavigation a {
    font-size: 16px;
    color: #333;
  }

  .BreadcrumbNavigation span {
    font-size: 16px;
    color: #ff4253;
  }

  .box_top {
    width: 100%;
    padding-bottom: 47px;
    background: url(../../assets/publicClass/Fixedbackground2.png) top repeat-y;
    padding-top: 17px;
    box-sizing: border-box;
    position: relative;
  }

  .box_top_box {
    width: 1180px;
    padding-bottom: 26px;
    background: #ffffff;
    border-radius: 10px;
    margin: 0 auto;
  }

  .box_top_box dl {
    width: 840px;
    padding-left: 20px;
    padding-top: 30px;
    float: left;
  }

  .box_top_box dl dt {
    width: 190px;
    background: #d8d8d8;
    border-radius: 10px;
    overflow: hidden;
    float: left;
    margin-right: 14px;
  }

  .box_top_box dl dt img {
    display: block;
    width: 100%;
  }

  .box_top_box dl dd {
    width: 602px;
    float: left;
  }

  .box_top_box dl h2 {
    font-weight: 500;
    font-size: 24px;
    color: #333;
    line-height: 30px;
    margin-bottom: 12px;
  }

  .box_top .p1 {
    height: 32px;
    margin-bottom: 12px;
  }

  .box_top .p1 span {
    display: inline-block;
    height: 28px;
    background: #ff707d;
    border-radius: 18px;
    font-size: 14px;
    color: #fff;
    line-height: 28px;
    margin-right: 8px;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .box_top .p2 {
    font-size: 16px;
    line-height: 16px;
    color: #333;
    margin-bottom: 8px;
  }

  .box_top .p2 strong {
    display: block;
    font-weight: 500;
    color: #333;
    line-height: 18px;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .box_top .p2 span {
    display: inline-block;
    padding: 0 10px;
    height: 24px;
    background: #ff8f00;
    border-radius: 4px;
    margin-right: 4px;
    line-height: 24px;
    color: #fff;
    font-size: 12px;
    margin-bottom: 4px;
  }

  .box_top .p3 span {
    display: block;
    line-height: 28px;
  }

  .box_top .p4 span {
    display: block;
    line-height: 28px;
  }

  .box_top .p4 p {
    width: 118px;
    height: 28px;
    line-height: 28px;
    border-radius: 2px;
    text-indent: 35px;
    font-size: 14px;
    color: #fff;
    background: url(../../assets/publicClass/p4.png) 10px no-repeat #ff4253;
  }

  .box_top .p5 span {
    display: block;
    line-height: 28px;
  }

  .box_top .p5 p {
    width: 118px;
    height: 28px;
    border-radius: 2px;
    text-indent: 35px;
    font-size: 14px;
    color: #333;
    background: url(../../assets/publicClass/p5.png) 10px no-repeat #f6f6f6;
  }

  .box_top_b {
    width: 1180px;
    height: 128px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 11px rgba(0, 0, 0, 0.02);
    border-radius: 12px;
    position: absolute;
    bottom: -95px;
    left: 50%;
    margin-left: -590px;
    padding-right: 40px;
    box-sizing: border-box;
  }

  .box_top_b strong {
    font-size: 36px;
    color: #333;
    line-height: 128px;
    padding-left: 50px;
    float: left;
  }

  .box_top_b span {
    float: right;
    display: block;
    width: 160px;
    height: 46px;
    line-height: 46px;
    box-shadow: 0px 0px 10px 6px #f5f6f6;
    border-radius: 23px;
    text-align: center;
    font-size: 24px;
    color: #fff;
    margin-top: 41px;
    cursor: pointer;
    cursor: pointer;
  }

  .box_top_b .ljyy {
    background: linear-gradient(90deg, #ff7c71 0%, #ff3250 100%);
  }

  .box_top_b .yyy {
    cursor: default;
    background: linear-gradient(180deg, #2fd672 0%, #33c059 100%);
  }

  .box_top_b .ljjr {
    width: 206px;
    background: linear-gradient(180deg, #ffd000 0%, #ffac00 100%);
  }

  .box_top_b .ckhf {
    background: linear-gradient(90deg, #7782fb 0%, #4e5cf6 100%);
  }

  .box_top_b .ckhf1 {
    background: #ececec;
    color: #333;
  }

  .main {
    padding-top: 143px;
    background: #fafafa;
    padding-bottom: 70px;
  }

  .main_top {
    width: 1180px;
    background: #ffffff;
    border-radius: 12px;
    margin: 0 auto;
  }

  .main_top .title {
    height: 91px;
    box-sizing: border-box;
    border-bottom: 1px #d5d5d5 solid;
    font-size: 20px;
    color: #333333;
    padding-left: 96px;
    padding-bottom: 27px;
    padding-top: 43px;
    text-align: left;
    font-weight: 500;
  }

  .main_top .main_top_center {
    padding: 50px 80px;
  }

  .main_top .main_top_center video {
    width: 1020px;
    height: 574px;
  }

  .main_top .main_top_center p {
    text-align: left;
    font-size: 14px;
    line-height: 24px;
    padding-bottom: 20px;
  }

  .main_bottom {
    width: 1180px;
    margin: 0 auto;
    padding-top: 66px;
  }

  .main_bottom .title {
    height: 77px;
    text-align: center;
  }

  .main_bottom .title span {
    display: inline-block;
    font-size: 28px;
    color: #333333;
    line-height: 56px;
    font-weight: 500;
    padding-right: 12px;
    padding-left: 13px;
    background: url(../../assets/publicClass/main_bottom2.png) right 34px no-repeat;
    position: relative;
  }

  .main_bottom .title span em {
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    background: url(../../assets/publicClass/main_bottom1.png) left top no-repeat;
  }

  .main_bottom .title span strong {
    position: relative;
    font-weight: normal;
  }

  .mani_list ul li {
    width: 280px;
    height: 346px;
    float: left;
    background: #ffffff;
    box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
    border-radius: 8px;
    overflow: hidden;
    margin-right: 20px;
    margin-bottom: 20px;
    transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -webkit-transition: all 0.25s ease-in;
    position: relative;
  }

  .mani_list ul li:hover {
    box-shadow: 0px 0px 10px 6px #f5f6f6;
    transform: translateY(-8px);
  }

  .mani_list ul li:nth-child(4n) {
    margin-right: 0;
  }

  .mani_list ul li dt {
    width: 280px;
    height: 174px;
    overflow: hidden;
  }

  .mani_list ul li dd {
    padding: 0 16px;
    padding-top: 20px;
    text-align: left;
  }

  .mani_list ul li dd h2 {
    font-size: 16px;
    color: #333;
    line-height: 16px;
    margin-bottom: 8px;
    font-weight: normal;
  }

  .mani_list ul li dd .p1 {
    width: 100%;
    font-size: 12px;
    color: #4e5cf6;
    line-height: 12px;
    margin-bottom: 8px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mani_list ul li dd .p2 {
    font-size: 12px;
    color: #666;
    line-height: 12px;
    margin-bottom: 24px;
  }

  .mani_list ul li dd .p3 {
    height: 38px;
  }

  .mani_list ul li dd .p3 em {
    display: block;
    width: 34px;
    height: 34px;
    border: 2px #f5f6f6 solid;
    border-radius: 38px;
    float: left;
    overflow: hidden;
    margin-right: 8px;
  }

  .mani_list ul li dd .p3 span {
    font-size: 14px;
    color: #333;
    line-height: 38px;
  }

  .mani_list ul li dd .p3 strong {
    font-size: 24px;
    float: right;
    line-height: 38px;
    color: #333;
  }

  .yycg_tan {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 460px;
    height: 560px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
    border-radius: 12px;
    margin-left: -230px;
    margin-top: -280px;
    box-sizing: border-box;
    text-align: center;
  }

  .yycg_tan img {
    margin: 0 auto;
    margin-top: 34px;
  }

  .yycg_tan h2 {
    font-size: 20px;
    text-align: center;
    color: #333333;
    line-height: 24px;
    margin-top: -8px;
    margin-bottom: 30px;
  }

  .yycg_tan p {
    margin: 0 auto;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    margin-bottom: 38px;
  }

  .yycg_tan span {
    display: block;
    width: 160px;
    height: 48px;
    background: linear-gradient(90deg, #7782fb 0%, #4e5cf6 100%);
    border-radius: 30px;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    line-height: 48px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/page2/publicClass/publicClass_details.vue